<template>
  <base-wrapper>
    <div class="space-y-4">
      <base-card title="Tambah Broadcast Baru">
        <form class="space-y-4" @submit.prevent="onSubmitNewBroadcast">
          <base-input label="Metode Pengiriman">
            <div class="flex gap-8">
              <base-radio
                label="Non-Official"
                val="non_official"
                id="metode_non_official"
                v-model="newBroadcast.type"
              />
              <base-radio
                label="Official"
                val="official"
                id="metode_official"
                v-model="newBroadcast.type"
              />
            </div>
          </base-input>
          <div :class="['grid gap-4', newBroadcast.type === 'official' ? 'grid-cols-2' : 'grid-cols-3']">
            <base-input
              fullwidth
              inset
              :shadow="false"
              label="Pilih File"
              size="padding-md"
              type="file"
              accept=".csv"
              @change="onChangeNewBroadcastFile"
            />
            <base-input v-if="newBroadcast.type === 'non_official'" fullwidth inset :shadow="false" label="Pilih Device">
              <base-select
                inset
                expand
                :options="deviceOptions"
                v-model="newBroadcast.deviceId"
              ></base-select>
            </base-input>
            <base-input fullwidth inset :shadow="false" label="Pilih Template">
              <base-select
                inset
                expand
                :options="templateOptions"
                v-model="newBroadcast.templateId"
              ></base-select>
            </base-input>
          </div>
          <base-button
            :disabled="
              (newBroadcast.type === 'non_official' && !newBroadcast.deviceId) ||
              !newBroadcast.file ||
              !newBroadcast.templateId
            "
            >Upload Broadcast</base-button
          >
        </form>
      </base-card>
      <base-card title="Riwayat Broadcast">
        <div class="space-y-4">
          <div class="flex justify-end gap-2">
            <base-input
              type="date"
              :shadow="false"
              v-model="filterBroadcasts.date"
              @change="loadBroadcasts"
            />
            <base-select
              :shadow="false"
              :options="[
                { key: 'null', label: 'Semua', value: null },
                { key: 'created', label: 'Menuggu Dimulai', value: 'created' },
                { key: 'started', label: 'Menuggu Diproses', value: 'started' },
                {
                  key: 'processing',
                  label: 'Sedang Diproses',
                  value: 'processing',
                },
                { key: 'finished', label: 'Selesai', value: 'finished' },
              ]"
              v-model="filterBroadcasts.status"
              @change="loadBroadcasts"
            />
            <base-input
              type="text"
              :shadow="false"
              placeholder="Cari pengguna"
              debounce
              v-model="filterBroadcasts.searchUserEmail"
              @native-input="loadBroadcasts"
            />
            <base-input
              type="text"
              :shadow="false"
              placeholder="Cari template"
              debounce
              v-model="filterBroadcasts.searchTemplateName"
              @native-input="loadBroadcasts"
            />
            <base-input
              type="text"
              :shadow="false"
              placeholder="Cari nomor (+62)"
              debounce
              v-model="filterBroadcasts.searchDevicePhoneNumber"
              @native-input="loadBroadcasts"
            />
          </div>
          <datatable
            :columns="[
              { id: 'date', name: 'Tanggal' },
              { id: 'finished_date', name: 'Tanggal Selesai' },
              { id: 'user', name: 'Pengguna' },
              { id: 'device_template', name: 'Device/Template' },
              { id: 'status', name: 'Status/Aksi', theadClass: 'text-center' },
              { id: 'download', name: 'Download', theadClass: 'text-center' },
            ]"
            :total="broadcasts.meta.page.total"
            :perPage="broadcasts.meta.page.perPage"
            :currentPage="broadcasts.meta.page.currentPage"
            @pagechanged="onChangePage"
          >
            <template #tbody="{ classes }">
              <tr
                v-for="broadcast in broadcasts.data"
                :key="broadcast.id"
                :class="[classes.tr, 'bg-white']"
              >
                <td :class="classes.td">
                  {{ broadcast.attributes.createdAt | formatDate }}
                </td>
                <td :class="classes.td">
                  {{ broadcast.attributes.finished_at | formatDate }}
                </td>
                <td :class="classes.td">
                  {{ broadcast.attributes.user_email }}
                </td>
                <td :class="classes.td">
                  {{ broadcast.attributes.device_phone_number }} /
                  {{ broadcast.attributes.template_name }}
                </td>
                <td :class="[classes.td, 'text-center']">
                  <div
                    v-if="broadcast.attributes.status === 'created'"
                    class="flex items-center justify-center gap-2"
                  >
                    <base-button size="sm" @click="onStartBroadcast(broadcast)"
                      >Start</base-button
                    >
                    <button
                      title="Hapus Broadcast"
                      @click="onDeleteBroadcast(broadcast)"
                    >
                      <Icon
                        icon="heroicons:x-mark"
                        class="h-5 w-5 text-red-600"
                      />
                    </button>
                  </div>
                  <base-badge
                    v-else
                    :color="statusColor[broadcast.attributes.status]"
                    >{{
                      statusMessage[broadcast.attributes.status]
                    }}</base-badge
                  >
                </td>
                <td :class="[classes.td, 'text-center']">
                  <div class="flex items-center justify-center gap-1">
                    <a
                      v-if="broadcast.attributes.file_url"
                      :href="broadcast.attributes.file_url"
                      title="Download File Import"
                    >
                      <Icon
                        icon="heroicons:arrow-down-tray"
                        class="text-green-600"
                      />
                    </a>
                    <a
                      v-if="broadcast.attributes.error_file_url"
                      :href="broadcast.attributes.error_file_url"
                      title="Download File Import Error"
                    >
                      <Icon
                        icon="heroicons:arrow-down-tray"
                        class="text-red-600"
                      />
                    </a>
                  </div>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </base-card>
    </div>
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import BaseRadio from '../../../../components/base/BaseRadio.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseRadio
  },
  data() {
    return {
      botRunning: false,
      broadcasts: {
        data: [],
        meta: {
          page: {},
        },
      },
      devices: [],
      templates: {
        data: [],
      },
      loadingBotStatus: true,
      loadingBroadcasts: true,
      loadingDevices: true,
      loadingNewBroadcast: false,
      loadingTemplates: false,
      loadingProcess: false,
      loadingDeleteBroadcast: false,
      newBroadcast: {
        type: 'non_official',
        deviceId: null,
        file: null,
        templateId: null,
      },
      filterBroadcasts: {
        date: null,
        status: null,
        searchUserEmail: null,
        searchTemplateName: null,
        searchDevicePhoneNumber: null,
      },
    };
  },
  computed: {
    deviceOptions() {
      return [
        { key: 'null', value: null, label: 'Pilih Device' },
        ...(this.botRunning
          ? this.devices
              .filter((device) => device.connected)
              .map((device) => ({
                key: device.device_id,
                value: device.device_id,
                label: `${device.name} - ${device.phone_number}`,
              }))
          : []),
      ];
    },
    loading() {
      return (
        this.loadingBotStatus ||
        this.loadingBroadcasts ||
        this.loadingDevices ||
        this.loadingNewBroadcast ||
        this.loadingTemplates ||
        this.loadingProcess ||
        this.loadingDeleteBroadcast
      );
    },
    statusColor() {
      return {
        created: 'yellow',
        started: 'yellow',
        processing: 'blue',
        finished: 'green',
      };
    },
    statusMessage() {
      return {
        created: 'Menuggu Dimulai',
        started: 'Menuggu Diproses',
        processing: 'Sedang Diproses',
        finished: 'Selesai',
      };
    },
    templateOptions() {
      return [
        { key: 'null', value: null, label: 'Pilih Template' },
        ...this.templates.data.map((template) => ({
          key: template.id,
          value: template.id,
          label: template.attributes.name,
        })),
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async checkBotStatus() {
      this.loadingBotStatus = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/status`);

      if (!err) {
        this.botRunning = res.running;
      }

      this.loadingBotStatus = false;
    },
    async getDevices() {
      this.loadingDevices = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/devices`);

      if (!err) {
        this.devices = res;
      }

      this.loadingDevices = false;
    },
    async loadTemplates() {
      this.loadingTemplates = true;

      const [res, err] = await this.request(
        `/api/v1/whatsapp-broadcast-templates`
      );

      if (!err) {
        this.templates = res;
      }

      this.loadingTemplates = false;
    },
    listenToBroadcast() {
      const channel = this.$pusher.subscribe('private-WhatsappBroadcast');

      channel.bind('WhatsappBroadcastUpdated', (e) => {
        const broadcastIndex = this.broadcasts.data.findIndex(
          (broadcast) => broadcast.id == e.model.id
        );

        if (broadcastIndex !== -1) {
          this.broadcasts.data[broadcastIndex].attributes.finished_at =
            e.model.finished_at;
          this.broadcasts.data[broadcastIndex].attributes.status =
            e.model.status;
          this.broadcasts.data[broadcastIndex].attributes.file_url = e.file_url;
          this.broadcasts.data[broadcastIndex].attributes.error_file_url =
            e.error_file_url;
        }
      });
    },
    async loadBroadcasts(params) {
      this.loadingBroadcasts = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-broadcasts`, {
        params: {
          'fields[whatsapp-broadcasts]':
            'status,createdAt,finished_at,user_email,rows_count,device_phone_number,template_name,file_url,error_file_url',
          'page[size]': 5,
          'filter[status]': this.filterBroadcasts.status,
          'filter[search_user_email]': this.filterBroadcasts.searchUserEmail,
          'filter[date]': this.filterBroadcasts.date,
          'filter[search_template_name]':
            this.filterBroadcasts.searchTemplateName,
          'filter[search_device_phone_number]':
            this.filterBroadcasts.searchDevicePhoneNumber,
          sort: '-id',
          ...params,
        },
      });

      if (!err) {
        this.broadcasts = res;
      }

      this.loadingBroadcasts = false;
    },
    onChangeNewBroadcastFile(e) {
      this.newBroadcast.file = e.target.files[0];
    },
    onChangePage(page) {
      this.loadBroadcasts({
        'page[number]': page,
      });
    },
    async onDeleteBroadcast(broadcast) {
      this.loadingDeleteBroadcast = true;

      const [, err] = await this.request(
        `/api/v1/whatsapp-broadcasts/${broadcast.id}`,
        {
          method: 'delete',
        }
      );

      if (!err) {
        this.loadBroadcasts();
      }

      this.loadingDeleteBroadcast = false;
    },
    async onStartBroadcast(target) {
      this.loadingProcess = true;

      await this.request(
        `/api/v1/whatsapp-broadcasts/${target.id}/-actions/start`,
        {
          method: 'patch',
        }
      );

      const broadcastIndex = this.broadcasts.data.findIndex(
        (broadcast) => broadcast.id == target.id
      );

      this.broadcasts.data[broadcastIndex].attributes.status = 'started';

      this.loadingProcess = false;
    },
    async onSubmitNewBroadcast() {
      this.loadingNewBroadcast = true;

      const data = new FormData();

      data.append('method', this.newBroadcast.type);
      data.append('device_id', this.newBroadcast.deviceId);
      data.append('file', this.newBroadcast.file);
      data.append('template_id', this.newBroadcast.templateId);

      const [, err] = await this.request(
        `/api/v1/whatsapp-broadcasts/-actions/create`,
        {
          method: 'post',
          data,
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Broadcast berhasil dibuat',
        });

        this.loadBroadcasts();
      }

      this.loadingNewBroadcast = false;
    },
    stopListenToBroadCast() {
      this.$pusher.unsubscribe('private-WhatsappBroadcast');
    },
  },
  created() {
    this.checkBotStatus();
    this.getDevices();
    this.loadBroadcasts();
    this.loadTemplates();
    this.listenToBroadcast();
  },
  destroyed() {
    this.stopListenToBroadCast();
  },
};
</script>
